import * as React from 'react';
import s from './Status.scss';
import { withTranslation } from '@wix/fe-essentials/i18n';
import { WithStatusLoader } from '../../loaders/loaders-builder';
import { PriceQuoteStatus } from '@wix/ambassador-wix-quotes-web/types';
import { PQStatusBadge } from '../../../index';
export const UoUStatuses = [
    PriceQuoteStatus.Accepted,
    PriceQuoteStatus.Invoiced,
    PriceQuoteStatus.Expired,
];
export const priceQuoteStatuses = [
    PriceQuoteStatus.Accepted,
    PriceQuoteStatus.Draft,
    PriceQuoteStatus.Sent,
    PriceQuoteStatus.Expired,
    PriceQuoteStatus.Invoiced,
];
const Status = ({ status, isUoU, t }) => {
    const renderedStatus = status;
    const isDisplayed = !isUoU || UoUStatuses.includes(renderedStatus);
    const text = t(`invoice-view:price-quote.view.status.${renderedStatus}`);
    return isDisplayed ? (React.createElement("div", { className: s.status, "data-hook": "status" },
        React.createElement(PQStatusBadge, { dataHook: "status-badge", status: status }, text))) : null;
};
export default WithStatusLoader(withTranslation(['invoice-view', 'locale-data'])(Status));
//# sourceMappingURL=Status.js.map